import axios from 'axios';
import { API_BASE_URL, AUTH_TOKEN_KEY } from 'constants/index';
import { useEffect, useState } from 'react';

interface IUseFetchRacksCapacityProps {
  pause?: boolean;
}

interface IResponseData {
  data: {
    available: number;
  };
  message: string;
  status_code: number;
}

export const useFetchRacksCapacity = (props: IUseFetchRacksCapacityProps) => {
  const { pause } = props;
  const [isFetching, setIsFetching] = useState(false);
  const [response, setResponse] = useState<IResponseData | null>(null);
  const [data, setData] = useState<IResponseData['data'] | null>(null);

  const fetching = async () => {
    setIsFetching(true);

    const fetchResponse = await axios
      .get<IResponseData>(`${API_BASE_URL}/users/consignments/capacity`, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
        },
      })
      .then((res) => {
        if (res.data?.status_code !== 200) {
          return {
            isSuccess: false,
            message: res.data?.message,
            data: res.data?.data,
            response: res.data,
          };
        }

        return {
          isSuccess: true,
          message: res.data.message,
          data: res.data.data,
          response: res.data,
        };
      })
      .catch((_err) => {
        return {
          isSuccess: false,
          message: null,
          data: null,
          response: null,
        };
      });

    setIsFetching(false);
    setData(fetchResponse.data);
    setResponse(fetchResponse.response);

    return fetchResponse;
  };

  useEffect(() => {
    if(pause){
      return;
    }
    
    const init = async () => {
      await fetching();
    };
    init();

    return () => {
      setIsFetching(false);
      setData(null);
      setResponse(null);
    };
  }, [pause]);

  return {
    isFetching,
    response,
    data,
    fetching,
  };
};
